'use client';

import urlJoin from 'url-join';
import { ORDERED_SEO_FRIENDLY_FACET_FILTERS } from '@libs/algolia';
import {
    FACETS_KEY,
    FACET_VALUE_SEPARATOR,
    URL_ENCODED,
} from '@app/plp/constants/facetedNavigation';

import type { UiState } from 'instantsearch.js';

type FilterValue = string[] | undefined;

const SEO_FRIENDLY_FACET_KEYS = Object.keys(ORDERED_SEO_FRIENDLY_FACET_FILTERS);

const formatFacetValues = (values: string[]) =>
    values.map(value =>
        encodeURIComponent(value.toLowerCase()).replaceAll(
            "'",
            URL_ENCODED.APOSTROPHE
        )
    );

const generateSeoFriendlyFacetPath = (facets: UiState) => {
    const facetsCollection: string[] = [];

    SEO_FRIENDLY_FACET_KEYS.forEach(key => {
        const facetValues = facets[key] as FilterValue;
        if (facetValues) {
            facetsCollection.push(
                ORDERED_SEO_FRIENDLY_FACET_FILTERS[key],
                formatFacetValues(facetValues)
                    .sort((a, b) => a.localeCompare(b))
                    .join(FACET_VALUE_SEPARATOR)
            );
        }
    });

    return facetsCollection.join('/').toLowerCase();
};

export const mapFacetValuesToUrl = (facets: UiState, location: Location) => {
    const slugs = location.pathname.split('/');
    const facetsIndex = slugs?.indexOf(FACETS_KEY);
    const hasFacets = facetsIndex >= 0;

    if (hasFacets) {
        slugs.splice(facetsIndex);
    }

    const seoFacetsPath = generateSeoFriendlyFacetPath(facets);
    const urlFacetKey = seoFacetsPath.length ? FACETS_KEY : '';

    return urlJoin('/', ...slugs, urlFacetKey, seoFacetsPath);
};

export const filterOutSeoFriendlyFacets = (facets: UiState) => {
    const filteredFacets: Record<string, FilterValue> = {};
    Object.keys(facets).forEach(key => {
        if (!SEO_FRIENDLY_FACET_KEYS.includes(key) && facets[key]) {
            filteredFacets[key] = facets[key] as FilterValue;
        }
    });
    return filteredFacets as UiState;
};
